import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { RevisionModel } from '../../../../api/api.types';
import { useTranslation } from 'react-i18next';
import { PricingApi } from '../../../../api/api.apiclient';
import AuditLog from '../../../../components/tables/AuditLog';
import { LoaderBar } from '../../../../components/forms/LoaderBar';

interface DiscountRuleAuditLogLocationProps {
  id: string;
}

const DiscountRuleAuditLog: React.FC<RouteComponentProps<DiscountRuleAuditLogLocationProps>> =
  (props) => {

    const [ revisions, setRevisions ] = useState<RevisionModel[]>([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
      const id = props.match.params.id;
      PricingApi.DiscountRules.getDiscountRuleRevisions(Number(id))
        .then((resp) => {
          setRevisions(resp.data);
        })
        .catch((err) => console.log(err))
        .finally(() => setIsLoading(false));
    }, [ props.match.params, t ]);

    return (
      <div className="page-content">
        <div className="row justify-content-end pb-2">
          <div className="col-12">
            <h1 className="mb-0">Discount rule {props.match.params.id} audit log</h1>
          </div>
        </div>
        {isLoading && <LoaderBar/>}
        <AuditLog
          revisions={revisions}
          jsonFieldNames={[ 'brokers', 'products', 'desks', 'carClasses', 'brokerRates' ]}
        />
      </div>
    );
  };
export default DiscountRuleAuditLog;